import { render, staticRenderFns } from "./overdue-order.vue?vue&type=template&id=a45d2112&scoped=true"
import script from "./overdue-order.vue?vue&type=script&lang=js"
export * from "./overdue-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45d2112",
  null
  
)

export default component.exports